<template>
  <label :for="'fileInput' + ct" class="file-select-label">
    <slot>
      <i class="fas fa-paperclip mr-10 text-grey" title="Fájl csatolás"></i>
    </slot>
    <input
      :id="'fileInput' + ct"
      class="file-select-input"
      type="file"
      ref="input"
      :accept="accept"
      @change="FileInput"
    />
  </label>
</template>

<script>
import { mapGetters } from 'vuex';
let ct = 0;
export default {
  name: 'file-select',
  data() {
    return { ct: ct++ };
  },
  mounted() {},
  created() {},
  methods: {
    FileInput(e) {
      const files = this.$refs.input.files;
      if (files.length == 0) {
        return;
      }
      this.$emit('input', files);
    },
  },
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  props: {
    accept: {
      tyle: String,
      default: '',
    },
  },
};
</script>
